(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  var HOVER_DEBOUNCE_MS = 300;
  var MAX_TEXT = 100;

  // ------------------------------------------------------------
  //  CONSENT GATE — nothing enters dataLayer without analytics consent
  // ------------------------------------------------------------
  function consentGranted() {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function') {
        return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
      }
      if (window.Cookiebot && window.Cookiebot.consent) {
        return window.Cookiebot.consent.statistics === true;
      }
    } catch (e) {}
    return false;
  }

  function push(event, clickText, linkDestination) {
    if (!consentGranted()) return;
    window.dataLayer.push({
      event: event,
      click_text: (clickText || '').replace(/\s+/g, ' ').trim().substring(0, MAX_TEXT),
      link_destination: linkDestination || ''
    });
  }

  function resolveUrl(u) {
    if (!u) return '';
    try { return new URL(u, window.location.origin).href; } catch (e) { return u; }
  }

  // Extract text + URL from a tagged element.
  // Priority: explicit data-gtag-text / data-gtag-link > summary[data-link] > href > textContent.
  function readPayload(el) {
    var text = el.getAttribute('data-gtag-text') || el.textContent || '';
    var url = el.getAttribute('data-gtag-link') ||
              el.getAttribute('data-link') ||
              el.href ||
              '';
    return { text: text, url: resolveUrl(url) };
  }

  // ------------------------------------------------------------
  //  DESKTOP — menu_hover on top-level (hover on the <li>, debounced)
  // ------------------------------------------------------------
  var hoverTimers = new WeakMap();
  var isTouchDevice = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;

  function bindDesktopHover() {
    if (isTouchDevice) return;
    // Desktop: hover on every tracked menu element (openers + leaf links).
    var SEL = '.header__menu [data-gtag="menu-top"], .header__menu [data-gtag="menu-link"]';
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.gtagBound) return;
      el.dataset.gtagBound = '1';

      el.addEventListener('mouseenter', function () {
        var timer = setTimeout(function () {
          var p = readPayload(el);
          push('menu_hover', p.text, p.url);
        }, HOVER_DEBOUNCE_MS);
        hoverTimers.set(el, timer);
      });
      el.addEventListener('mouseleave', function () {
        var t = hoverTimers.get(el);
        if (t) { clearTimeout(t); hoverTimers.delete(el); }
      });
    });
  }

  // ------------------------------------------------------------
  //  MOBILE — menu_hover fires when a top-level <summary> is tapped (opens panel)
  // ------------------------------------------------------------
  function bindMobileTopTap() {
    // Mobile equivalent of hover: any <summary> that opens a submenu panel
    // (top-level drawer summary + nested accordion summary for grandchildren).
    document.querySelectorAll('menu-drawer summary[data-gtag="menu-top"]').forEach(function (sum) {
      if (sum.dataset.gtagBound) return;
      sum.dataset.gtagBound = '1';

      sum.addEventListener('click', function () {
        // Native <summary> toggles <details>; we don't interfere.
        var p = readPayload(sum);
        push('menu_hover', p.text, p.url);
      });
    });
  }

  // ------------------------------------------------------------
  //  DELEGATED CLICKS — menu_click, collection_tile_click, parent_category_click
  // ------------------------------------------------------------
  // Capture phase so we run before any theme handler that might stopPropagation.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var tagged = e.target.closest('[data-gtag]');
    if (!tagged) return;

    var kind = tagged.getAttribute('data-gtag');

    switch (kind) {
      case 'collection-tile': {
        var p = readPayload(tagged);
        push('collection_tile_click', p.text, p.url);
        return;
      }
      case 'parent-category': {
        var p2 = readPayload(tagged);
        push('parent_category_click', p2.text, p2.url);
        return;
      }
      case 'menu-link': {
        // Actual navigation inside the menu (any level).
        var p3 = readPayload(tagged);
        push('menu_click', p3.text, p3.url);
        return;
      }
      case 'menu-top': {
        // Top-level opener. Fire menu_click ONLY if it actually navigates
        // (plain <a>), not when it just toggles a <details> panel.
        if (tagged.tagName === 'A' && tagged.href) {
          var p4 = readPayload(tagged);
          push('menu_click', p4.text, p4.url);
        }
        return;
      }
    }
  }, true);

  // ------------------------------------------------------------
  //  INIT
  // ------------------------------------------------------------
  function init() {
    bindDesktopHover();
    bindMobileTopTap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
